<template>
<div>
    
    <div class="pagination-dots for_desktop">
        <span 
        v-for="page in totalPage" 
        :key="page"
        :class="{'active-dot': currentPage >= page}"
        class="dot"
        @click="goToPage(page)">
        </span>
    </div>
</div>
</template>

<script setup>
import { diamondQuizStore } from '@/stores/diamond_quiz/diamond_quiz';

const store = diamondQuizStore()
const currentPage = ref(store.currentPage); 
const totalPage = 5;

// const emit = defineEmits(['nextPage'])

// const props = defineProps({
//   currentPage: Number,
//   totalPage: Number
// });

// const emitNextPage = () => {
//   emit('nextPage')
// }


const goToPage = (page) => {
  if (page < currentPage.value) {
    store.currentPage = page; 
  }
};

watch(() => store.currentPage, (newPage) => {
  currentPage.value = newPage;
});


</script>


<style scoped>
.button {
    padding: 14px 30px;
    border: 1.5px solid var(--green);
    border-radius: 4px;
    width: 40%;
    margin: 0 auto;
    background: var(--green);
    cursor: pointer;
    margin-bottom: 3%;
}

.button span {
    font-size: 14px;
    letter-spacing: 1.4px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
}

.pagination-dots {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  /* margin-top: 5%; */
  /* position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%); */
}

.dot {
  height: 10px;
  width: 10px;
  margin: 0 5px;
  background-color: #c4c4c4;
  border-radius: 50%;
  cursor: pointer;
  
}

.active-dot {
  background-color: var(--green);
}

@media(max-width:992px){
    .button {
        max-width: 60%;
        padding: 10px 15px;
    }

}

@media(max-width:768px) {
    .button {
        max-width: 100%;
       
    }
}
</style>